var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/Pencil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 52",
    d: "M27.25 1.75L5.85139 17.2167L3.94184 24.2723L10.9511 24.2723L32.3497 8.80557L27.25 1.75Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M7.52344 16.3921L12.2032 22.8404",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M9.67188 19.5755L29.4071 5.56982",
    stroke: "#102D3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M9.85156 24.25L31.1016 24.25",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.c4363e132b80a5363b94b17a195e632d.svg";
export { ForwardRef as ReactComponent };